import { useEffect, useState } from "react";
import { Sun } from "lucide-react";

const links = [
  { id: "project", label: "Project" },
  { id: "location", label: "Location" },
  { id: "layout", label: "Layout" },
  { id: "information", label: "Information" },
  { id: "planning", label: "Planning" },
  { id: "developer", label: "Developer" },
  { id: "book", label: "Information days" },
  { id: "contact", label: "Contact" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 z-50 transition-colors duration-300 border-b ${
        scrolled
          ? "bg-[#F9F8F6]/95 backdrop-blur-md border-[#E0DCD3]"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-16 flex items-center justify-between">
        <button
          onClick={() => go("top")}
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-sm bg-[#3A4B3A] text-white">
            <Sun className="h-4 w-4" strokeWidth={2.2} />
          </span>
          <span className="font-serif-display text-[1.05rem] tracking-tight text-[#2A2B2A]">
            Loughrea Solar Farm
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-[13px] tracking-wide text-[#2A2B2A] link-underline"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => go("book")}
          data-testid="nav-cta-book"
          className="hidden md:inline-flex h-9 items-center px-4 rounded-sm bg-[#3A4B3A] text-white text-[13px] font-medium hover:bg-[#2A3B2A] transition-colors"
        >
          Information days
        </button>

        <button
          className="md:hidden inline-flex h-9 w-9 items-center justify-center rounded-sm border border-[#E0DCD3]"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          <div className="space-y-1">
            <span className="block h-px w-5 bg-[#2A2B2A]"></span>
            <span className="block h-px w-5 bg-[#2A2B2A]"></span>
            <span className="block h-px w-5 bg-[#2A2B2A]"></span>
          </div>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E0DCD3] bg-[#F9F8F6]" data-testid="mobile-menu">
          <div className="px-6 py-4 grid gap-3">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`mobile-nav-link-${l.id}`}
                className="text-left text-[14px] text-[#2A2B2A]"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => go("book")}
              data-testid="mobile-cta-book"
              className="mt-2 inline-flex h-10 items-center justify-center px-4 rounded-sm bg-[#3A4B3A] text-white text-[13px] font-medium"
            >
              Information days
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
